import type {LearnableContentKind} from "#content-library/types/types.ts";
import type {ContentItemCompletionStatus} from "#shared-package/types.ts";

import {PROGRAM_STATUS, type ProgramStatus} from "../types.ts";

/**
 * A utility that takes in the content item completion status and maps it to
 * a Challenge/Project "challengeStatus".
 */
export const mapCompletionStatusToChallengeStatus = (
    completionStatus: ContentItemCompletionStatus,
    contentKind: LearnableContentKind | string,
): ProgramStatus => {
    switch (contentKind) {
        case "Challenge": {
            if (completionStatus === "COMPLETE") {
                return PROGRAM_STATUS.CHALLENGE_COMPLETE;
            }
            if (completionStatus === "STARTED") {
                return PROGRAM_STATUS.CHALLENGE_STARTED;
            }
            return PROGRAM_STATUS.CHALLENGE_NOT_STARTED;
        }
        case "Project": {
            if (completionStatus === "COMPLETE") {
                return PROGRAM_STATUS.PROJECT_PASS;
            }
            if (completionStatus === "STARTED") {
                return PROGRAM_STATUS.PROJECT_STARTED;
            }
            // NOTE: PROJECT_NOT_STARTED is unused. Now that Projects no longer
            // rely on spin-offs to track progress, both Projects and Challenge
            // default to a -1 challangeStatus to represent an UNSTARTED state.
            return PROGRAM_STATUS.CHALLENGE_NOT_STARTED;
        }
        default:
            // ChallengeStatus isn't used for any other content kind. The
            // default value is CHALLENGE_NOT_STARTED so we just return that.
            return PROGRAM_STATUS.CHALLENGE_NOT_STARTED;
    }
};
